//TODO - It should be considered if we want to remove some statuses, not all of them are used
export enum INVITE_STATUSES {
  ACTIVE = 'active',
  ACCEPTED = 'accepted',
  EXERCISED = 'exercised',
  DISABLED = 'disabled',
  DECLINED = 'declined',
  EXPIRED = 'expired',
}
